import { render } from "./LoadingComponent.vue?vue&type=template&id=3a5590b7&scoped=true"
const script = {}

import "./LoadingComponent.vue?vue&type=style&index=0&id=3a5590b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5590b7"]])

export default __exports__